//
// Image Fader
// --------------------------------------------------
// Can be used when multiple images are added to an asset section to fade through the multiple images
// REQUIRES* specific markup setup, for examples search projects for the content-image-fader or picture-target class.

window.addEventListener('load', () => {
    const faderList = document.querySelectorAll('.content-image-fader');
    if (faderList.length) {
        for (let fader of faderList) {
            const imgList = fader.querySelectorAll('.picture-target');

            // Delay should match the duration of the opacity transition + delays
            let delay = 3000;

            // Set Interval Delay - can be used for multiple images to fade in sequence
            let intervalDelay = 0;

            if (fader.dataset.intervaldelay) {
                intervalDelay = parseInt(fader.dataset.intervaldelay);
            }

            // Timer can be adjusted as required on panel
            let timer = parseInt(fader.dataset.fadetimer);

            // If timer data attribute not defined or set default to 5000ms
            if (fader.dataset.fadetimer === null) {
                timer = 5000;
            }

            function fadeImg() {
                for (let img of imgList) {
                    if (img === fader.firstElementChild) {
                        img.classList.add('!opacity-0');

                        const shiftImageToBack = setTimeout(() => {
                            fader.appendChild(img);
                            clearTimeout(shiftImageToBack);
                        }, delay);

                        const resetImg = setTimeout(() => {
                            img.classList.remove('!opacity-0');
                            clearTimeout(resetImg);
                        }, timer);
                    } else {
                        if (img.classList.contains('hidden')) {
                            img.classList.remove('hidden');
                            setTimeout(function() {
                                img.classList.remove('!opacity-0');
                            }, 50)
                        }
                    }

                }
            }

            fadeImg();

            setTimeout(function() {
                setInterval(() => {
                    fadeImg();
                }, timer);
            }, intervalDelay)
        }
    }
})